import Logo from '../../../assets/Logo-tight-white.png';

function Faq() {
  return (
    <section className='mt-16' id='faq'>
      <div className='max-w-6xl mx-auto px-4 sm:px-6'>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-3 leading-tighter'>What is The 100 Club?</h3>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            The 100 Club is a private mastermind community for founders in Singapore.
          </p>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            Members of The 100 Club run growing businesses in Singapore, across a wide array of industries. Some are
            bootstrapped, others venture-backed. But all our members seek belonging, support, and connection with a
            selective group of their peers.
          </p>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            Members who join us get matched into a mastermind group of 8 founders with an executive facilitator, that
            meets every month to discuss business challenges. Additionally, they can expect to be part of a digital
            community, an in-person community, have access to speakers, and a membership card to claim perks throughout
            Singapore.
          </p>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-10 leading-tighter'>
            What are the member benefits?
          </h3>
          <div className='max-w-sm mx-auto grid gap-6 md:grid-cols-2 lg:grid-cols-3 items-start md:max-w-2xl lg:max-w-none mb-12'>
            {/* 1st item */}
            <div className='relative flex flex-col items-center justify-center p-10 bg-primary-main rounded shadow-xl h-full'>
              <img src={Logo} alt={'logo'} style={{ maxWidth: '70%', maxHeight: '200px' }} />
            </div>
            {/* 2nd item */}
            <div className='relative flex flex-col items-left text-left bg-highlight-eggshell p-7 rounded-md border h-full'>
              <h4 className='text-2xl font-bold mb-1'>Monthly Masterminds</h4>
              <p className='text-lg font-montreal leading-snug'>
                A group of 8 founders we match with an executive facilitator, that meets every month to discuss personal
                and business problems.
              </p>
            </div>
            <div className='relative flex flex-col items-left text-left bg-highlight-eggshell p-7 rounded-md border h-full'>
              <h4 className='text-2xl font-bold mb-1'>Digital Community</h4>
              <p className='text-lg font-montreal leading-snug'>
                Access to a telegram community of highly engaged founders who provide helpful advice, a dedicated
                digital concierge, and online membership portal.
              </p>
            </div>{' '}
            <div className='relative flex flex-col items-left text-left bg-highlight-eggshell p-7 rounded-md border h-full'>
              <h4 className='text-2xl font-bold mb-1'>In-Person Community</h4>
              <p className='text-lg font-montreal leading-snug'>
                Our in-person event strategy is focused around three pillars: monthly modern events, monthly teh peng
                chats, and annual adventures.
              </p>
            </div>{' '}
            <div className='relative flex flex-col items-left text-left bg-highlight-eggshell p-7 rounded-md border h-full'>
              <h4 className='text-2xl font-bold mb-1'>Speakers & Education</h4>
              <p className='text-lg font-montreal leading-snug'>
                We know how important it is to have access to the best and brightest. So, we host unique workshops and
                bring in experts across a variety of topics.
              </p>
            </div>{' '}
            <div className='relative flex flex-col items-left text-left bg-highlight-eggshell p-7 rounded-md border h-full'>
              <h4 className='text-2xl font-bold mb-1'>Exclusive Perks</h4>
              <p className='text-lg font-montreal leading-snug'>
                All members who join us get a smart 100Card, which they can use at select locations throughout Singapore
                for exclusive discounts.
              </p>
            </div>
          </div>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-3 leading-tighter'>What is a mastermind?</h3>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            Monthly mastermind group meetings are the cornerstone of The 100 Club experience. It's a peer support group
            of 8-10 founders at a similar business stage, that meet monthly to work through their challenges in a safe
            environment.
          </p>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-3 leading-tighter'>
            Do I need to pay for this?
          </h3>

          <p className='text-xl md:text-2xl text-text-main mb-8'>Nope, it's a 30-day free trial.</p>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-3 leading-tighter'>
            What do I need to do to join?
          </h3>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            Apply through the form, and we'll reach out to schedule a call with you. It'll be a discovery call to see
            whether you're a good fit for the community!
          </p>
        </div>
        <div className='text-center'>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
      </div>
    </section>
  );
}

export default Faq;
